module.exports = __webpack_public_path__ + "img/marker-gral-small_dorada.957653d2.png";